(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["albalina-achat"] && !Shopify.designMode) return;
  try {
    /* Le compte à rebours garde son échéance dans le navigateur : il ne repart
     pas de zéro à chaque rechargement, ce qui se voit tout de suite. Une fois
     passé, il se réarme pour le lendemain, comme le mode quotidien de Velt-ro. */
  class AlbalinaMinuteur extends HTMLElement {
    connectedCallback() {
      this.h = this.querySelector('[data-h]');
      this.min = this.querySelector('[data-min]');
      this.sec = this.querySelector('[data-sec]');
      this.duree = (parseInt(this.dataset.minutes, 10) || 290) * 60000;
      this.fin = this.echeance(this.duree);
      this.battre();
      this.horloge = setInterval(() => this.battre(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.horloge);
    }

    echeance(duree) {
      const cle = 'albalina:minuteur-h';
      let f = 0;
      try {
        f = parseInt(localStorage.getItem(cle), 10) || 0;
      } catch (e) {
        f = 0;
      }
      if (!f || f < Date.now()) {
        f = Date.now() + duree;
        try {
          localStorage.setItem(cle, String(f));
        } catch (e) {
          /* navigation privée : le minuteur vit le temps de la page */
        }
      }
      return f;
    }

    battre() {
      /* 29 sept. 2026, Quentin : 4 h 50 au départ, puis ça déroule ; à zéro,
         une nouvelle échéance repart au lieu de rester figée sur 00:00. */
      if (this.fin <= Date.now()) this.fin = this.echeance(this.duree);
      const reste = Math.max(0, this.fin - Date.now());
      const h = Math.floor(reste / 3600000);
      const m = Math.floor((reste % 3600000) / 60000);
      const s = Math.floor((reste % 60000) / 1000);
      if (this.h) this.h.textContent = String(h).padStart(2, '0');
      if (this.min) this.min.textContent = String(m).padStart(2, '0');
      if (this.sec) this.sec.textContent = String(s).padStart(2, '0');
    }
  }

  /* 29 sept. 2026, Quentin : la pastille d'avis mène aux avis avec photos */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ab-vers-avis]');
    if (!a) return;
    /* 12 oct. 2026, Quentin : sur la V2 (?view=v2), la pastille mène aux avis du bas de page */
    var cible = a.getAttribute('data-ab-vers-avis') === 'liste'
      ? (document.querySelector('.ab-avis__liste') || document.querySelector('.ab-avis2'))
      : (document.querySelector('.ab-temoin') || document.querySelector('.ab-avis__liste'));
    if (!cible) return;
    e.preventDefault();
    window.scrollTo({ top: cible.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
  });

  if (!customElements.get('albalina-minuteur')) {
    customElements.define('albalina-minuteur', AlbalinaMinuteur);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["albalina-galerie"] && !Shopify.designMode) return;
  try {
    class AlbalinaGalerie extends HTMLElement {
    connectedCallback() {
      this.monter();
      /* Horizon reconstruit slideshow-controls après coup, ce qui emporte
         l'enveloppe et les flèches. On les repose dès qu'elles disparaissent. */
      this.veille = new MutationObserver(() => {
        if (this.pose) return;
        if (document.querySelector('.ab-galerie__fleche')) return;
        this.pose = true;
        requestAnimationFrame(() => {
          this.monter();
          this.pose = false;
        });
      });
      this.veille.observe(document.body, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this.veille) this.veille.disconnect();
      if (this.observateur) this.observateur.disconnect();
    }

    monter(essai) {
      const n = essai || 0;
      const rangee = document.querySelector('.slideshow-controls__thumbnails-container');
      if (!rangee) {
        if (n < 25) setTimeout(() => this.monter(n + 1), 150);
        return;
      }
      if (rangee.parentElement.classList.contains('ab-galerie')) return;
      if (this.observateur) this.observateur.disconnect();

      const enveloppe = document.createElement('div');
      enveloppe.className = 'ab-galerie';
      rangee.parentElement.insertBefore(enveloppe, rangee);
      enveloppe.appendChild(rangee);

      this.gauche = this.fleche('gauche');
      this.droite = this.fleche('droite');
      enveloppe.appendChild(this.gauche);
      enveloppe.appendChild(this.droite);

      this.rangee = rangee;
      this.gauche.addEventListener('click', () => this.aller(-1));
      this.droite.addEventListener('click', () => this.aller(1));
      rangee.addEventListener('click', () => setTimeout(() => this.etat(), 120));
      this.observateur = new MutationObserver(() => this.etat());
      this.observateur.observe(rangee, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-selected'],
      });
      this.etat();
      this.boucleDoigt();
    }

    /* Au doigt : un glissé vers la gauche sur la dernière image ramène à la
       première, un glissé vers la droite sur la première mène à la dernière.
       Au milieu, on laisse Horizon faire défiler normalement. */
    boucleDoigt() {
      const zone = document.querySelector('.product-information__media slideshow-slides, .product-information__media .slideshow-slides, .product-information__media');
      if (!zone || zone.dataset.abBoucle) return;
      zone.dataset.abBoucle = '1';
      let x0 = null, y0 = null, zoome = false;
      zone.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; zoome = e.touches.length > 1 || !!document.querySelector('.product-information__media .ab-zoome'); }, { passive: true });
      zone.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        if (zoome || e.touches.length) { x0 = null; return; } /* on se balade dans une image zoomée, ce n'est pas un balayage */
        const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        const v = this.vignettes();
        const i = v.findIndex((t) => t.getAttribute('aria-selected') === 'true');
        if (dx < 0 && i === v.length - 1) setTimeout(() => this.aller(1), 60);
        else if (dx > 0 && i === 0) setTimeout(() => this.aller(-1), 60);
      }, { passive: true });
    }

    fleche(sens) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ab-galerie__fleche ab-galerie__fleche--' + sens;
      b.setAttribute('aria-label', sens === 'gauche' ? 'Image précédente' : 'Image suivante');
      const s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('aria-hidden', 'true');
      s.style.transform = sens === 'gauche' ? 'rotate(135deg)' : 'rotate(-45deg)';
      b.appendChild(s);
      return b;
    }

    vignettes() {
      return [...this.rangee.querySelectorAll('.slideshow-controls__thumbnail')];
    }

    aller(pas) {
      const v = this.vignettes();
      const i = v.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      /* 29 sept. 2026, Quentin : la galerie tourne en boucle, après la dernière on revient à la première */
      const cible = v[((i < 0 ? 0 : i) + pas + v.length) % v.length];
      if (!cible) return;
      cible.click();
      /* Jamais scrollIntoView : il fait défiler tous les parents scrollables,
         y compris le carrousel lui-même, et la grande image partait de travers.
         On déplace uniquement la rangée. */
      this.amener(cible);
      setTimeout(() => this.etat(), 150);
    }

    amener(cible) {
      const r = this.rangee;
      const marge = 28;
      const g = cible.offsetLeft - marge;
      const d = cible.offsetLeft + cible.offsetWidth + marge - r.clientWidth;
      if (g < r.scrollLeft) r.scrollLeft = g;
      else if (d > r.scrollLeft) r.scrollLeft = d;
    }

    etat() {
      const v = this.vignettes();
      const i = v.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      if (this.gauche) this.gauche.disabled = false;
      if (this.droite) this.droite.disabled = false;
    }
  }

  if (!customElements.get('albalina-galerie')) {
    customElements.define('albalina-galerie', AlbalinaGalerie);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["albalina-paliers"] && !Shopify.designMode) return;
  try {
    class AlbalinaPaliers extends HTMLElement {
    connectedCallback() {
      this.nom = this.dataset.nomOption || 'Lot';
      this.addEventListener('click', this.surClic);
      document.addEventListener('change', this.surChangement);
      this.surveiller();
      this.demarrer();
    }

    /* Le sélecteur de variantes natif n'est pas forcément monté quand ce bloc
       se connecte : sans radios, la présélection et le libellé du bouton
       passaient silencieusement à la trappe. On attend qu'il soit là. */
    demarrer(essai) {
      const n = essai || 0;
      if (this.radios().length === 0 && n < 25) {
        setTimeout(() => this.demarrer(n + 1), 150);
        return;
      }
      this.preselectionner();
      this.synchroniser();
    }

    /* Le palier du milieu est présélectionné : relevé le 23 sept. 2026 sur
       velt-ro.com et maison-maeline.com (MoonBundle, defaultIdx 1) et sur
       myaalyra.com (Kaching). Trois annonceurs sur quatre.
       Shopify n'offre pas de variante par défaut arbitraire : l'ordre des
       variantes commande aussi l'ordre d'affichage des valeurs d'option, et
       l'échelle doit se lire en montant. La sélection se fait donc ici, comme
       le font les applications de bundle du marché.
       On ne touche à rien si la cliente arrive sur une variante précise. */
    preselectionner() {
      if (new URLSearchParams(location.search).has('variant')) return;
      const rang = parseInt(this.dataset.palierDefaut, 10);
      if (!rang) return;
      const carte = this.querySelectorAll('.ab-palier')[rang - 1];
      if (!carte) return;
      const cible = this.radios().find((r) => r.value === carte.dataset.valeur);
      if (cible && !cible.checked) cible.click();
      this.marquer(carte.dataset.valeur);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.surChangement);
      if (this.observateur) this.observateur.disconnect();
    }

    radios() {
      return Array.from(
        document.querySelectorAll(
          'input[type="radio"][data-option-name="' + CSS.escape(this.nom) + '"]'
        )
      );
    }

    surClic = (e) => {
      const carte = e.target.closest('.ab-palier');
      if (!carte) return;
      const cible = this.radios().find((r) => r.value === carte.dataset.valeur);
      if (!cible || cible.checked) return;
      cible.click();
      this.marquer(carte.dataset.valeur);
    };

    surChangement = (e) => {
      const r = e.target;
      if (r && r.dataset && r.dataset.optionName === this.nom) {
        this.marquer(r.value);
      }
    };

    synchroniser() {
      const coche = this.radios().find((r) => r.checked);
      if (coche) {
        this.marquer(coche.value);
        return;
      }
      const actif = this.querySelector('.ab-palier.is-actif');
      if (actif) this.marquer(actif.dataset.valeur);
    }

    marquer(valeur) {
      let quantite = null;
      const connue = [...this.querySelectorAll('.ab-palier')].some(
        (c) => c.dataset.valeur === valeur
      );
      if (!connue) return;
      this.querySelectorAll('.ab-palier').forEach((c) => {
        const actif = c.dataset.valeur === valeur;
        c.classList.toggle('is-actif', actif);
        c.setAttribute('aria-pressed', actif ? 'true' : 'false');
        if (actif) quantite = c.dataset.quantite;
      });
      if (quantite) this.libelleBouton();
    }

    /* Le type de produit ET la quantité dans le bouton : cro.md L153-157,
       checklist.md G34. Le regard va au titre, à l'image et au bouton.

       Piège payé : écrire dans .add-to-cart-text écrase l'icône et les
       références « quantityDisplay » et « quantityNumber » dont le composant
       sticky-add-to-cart de Horizon a besoin, ce qui lève un MissingRefError.
       On ne touche donc QUE le nœud qui porte le libellé.

       Les deux boutons n'ont pas le même balisage :
       - le bouton principal porte le libellé dans un nœud de texte nu ;
       - le bouton collant le porte dans le premier span de
         .add-to-cart-text__content, suivi du span de quantité. */
    libelleBouton() {
      this.poser();
    }

    /* Sans état : le libellé se recalcule depuis le palier actif à chaque
       appel. Horizon remplace le formulaire et la barre collante à chaque
       changement de variante, donc toute valeur gardée en mémoire sur
       l'instance est perdue. */
    poser() {
      const gabarit = this.dataset.gabaritBouton;
      if (!gabarit) return;
      const actif =
        this.querySelector('.ab-palier.is-actif') || this.querySelector('.ab-palier');
      if (!actif || !actif.dataset.quantite) return;
      /* une seule culotte : « Je prends ma culotte », jamais « mes 1 culottes » */
      const texte = actif.dataset.quantite === '1' && this.dataset.gabaritUn
        ? this.dataset.gabaritUn
        : gabarit.replace('{n}', actif.dataset.quantite);

      document.querySelectorAll('button.add-to-cart-button').forEach((bouton) => {
        const contenu = bouton.querySelector('.add-to-cart-text__content');
        if (contenu) {
          const span = contenu.querySelector(':scope > span');
          if (span && span.textContent.trim() !== texte) span.textContent = texte;
          return;
        }
        const noeud = [...bouton.childNodes].find(
          (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim().length > 0
        );
        if (noeud && noeud.textContent.trim() !== texte) noeud.textContent = ' ' + texte + ' ';
      });
    }

    /* Horizon reconstruit le bouton collant et le formulaire à chaque
       changement de variante : on repose le libellé après coup. */
    surveiller() {
      if (this.observateur) return;
      this.observateur = new MutationObserver(() => {
        if (this.enCours) return;
        this.enCours = true;
        requestAnimationFrame(() => {
          this.poser();
          this.enCours = false;
        });
      });
      this.observateur.observe(document.body, { childList: true, subtree: true });
    }

  }

  if (!customElements.get('albalina-paliers')) {
    customElements.define('albalina-paliers', AlbalinaPaliers);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["albalina-unites"] && !Shopify.designMode) return;
  try {
    class AlbalinaUnites extends HTMLElement {
    connectedCallback() {
      /* Le panneau (guide, en-tetes, lignes) est un simple <div> que ce pilote
         construit une fois et pose sous la carte du pack choisi. On ne deplace
         jamais l'element personnalise lui-meme : Horizon reconstruit la fiche
         a chaque changement de variante et en refabriquait une copie a chaque
         fois (releve le 6 oct. 2026). */
      if (!this.panneau) {
        this.panneau = document.createElement('div');
        this.panneau.className = 'ab-unites ab-unites--panneau';
        while (this.firstChild) this.panneau.appendChild(this.firstChild);
      }
      this.liste = this.panneau.querySelector('[data-liste]');
      /* un ancien panneau orphelin (fiche reconstruite) ne doit pas rester */
      document.querySelectorAll('.ab-unites--panneau').forEach((p) => {
        if (p !== this.panneau) p.remove();
      });
      this.coloris = JSON.parse(this.dataset.coloris || '[]');
      this.tailles = JSON.parse(this.dataset.tailles || '[]');
      this.teintes = {};
      (this.dataset.teintes || '').split(',').forEach((p) => {
        const [n, h] = p.split(':');
        if (n && h) this.teintes[n.trim()] = h.trim();
      });
      try {
        this.vignettes = JSON.parse(this.dataset.vignettes || '{}');
      } catch (e) {
        this.vignettes = {};
      }
      this.placer();
      if (this.liste.children.length !== this.quantite()) this.rendre(this.quantite());
      document.addEventListener('change', this.surChangement);
      document.addEventListener('click', this.fermerMenus);
      document.addEventListener('albalina:pack', this.depuisPanier);
      this.surveiller();
      if (this.hasAttribute('data-panier-unites')) {
        /* Les variantes du produit à l'unité (Coloris et Taille seulement) :
           « Beige / M » au paiement au lieu de « 1 culotte / M / Beige ».
           Tant qu'elles ne sont pas lues, le bouton envoie le lot comme avant. */
        if (!this.unites) {
          fetch((window.Shopify?.routes?.root || '/') + 'products/' + this.dataset.produitUnite + '.js')
            .then((r) => r.json())
            .then((p) => {
              const iC = p.options.findIndex((o) => o.name === 'Coloris');
              const iT = p.options.findIndex((o) => o.name === 'Taille');
              if (iC < 0 || iT < 0) return;
              const m = {};
              p.variants.forEach((v) => { if (v.available) m[v.options[iC] + '|' + v.options[iT]] = v.id; });
              this.unites = m;
            })
            .catch((err) => console.warn('[albalina-unites] produit à l’unité', err));
        }
        window.addEventListener('submit', this.envoyer, true);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.surChangement);
      document.removeEventListener('click', this.fermerMenus);
      document.removeEventListener('albalina:pack', this.depuisPanier);
      window.removeEventListener('submit', this.envoyer, true);
      if (this.veille) this.veille.disconnect();
      if (this.panneau) this.panneau.remove();
    }

    /* Idempotent : ne bouge que si le panneau n'est pas deja juste apres la
       carte active (ou, faute de carte, juste apres le pilote). */
    placer() {
      if (!this.isConnected) return;
      const actif = document.querySelector('.ab-palier.is-actif');
      const cible = actif || this;
      if (cible.nextElementSibling !== this.panneau) cible.after(this.panneau);
    }

    vignetteDe(nom) {
      const u = this.vignettes[nom] || this.dataset.vignette;
      /* 96 px suffisent pour une vignette de 28 a 36 px : 13 Ko au lieu de 65 */
      return u.includes('cdn.shopify.com') && !u.includes('width=') ? u + (u.includes('?') ? '&' : '?') + 'width=96' : u;
    }

    /* Le choix de coloris avec photo de la culotte, branche sur un <select>.
       Sert au bloc du haut ET a la feuille d'achat (barre collante), qui
       passe le <select> du haut : meme rendu, aucun code en double.
       `signal` (facultatif) retire l'ecouteur quand la feuille se reconstruit. */
    champColoris(selC, signal, i) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ab-unites__btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Coloris ' + ((i || 0) + 1));
      const mini = document.createElement('img');
      mini.className = 'ab-unites__mini';
      mini.alt = '';
      const txt = document.createElement('span');
      txt.className = 'ab-unites__txt';
      btn.append(mini, txt);

      const menu = document.createElement('div');
      menu.className = 'ab-unites__menu';
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;

      const peindre = () => {
        mini.src = this.vignetteDe(selC.value);
        txt.textContent = selC.value;
        menu.querySelectorAll('.ab-unites__opt').forEach((o) => {
          o.setAttribute('aria-selected', o.dataset.nom === selC.value ? 'true' : 'false');
        });
      };

      this.coloris.forEach((c) => {
        const o = document.createElement('button');
        o.type = 'button';
        o.className = 'ab-unites__opt';
        o.setAttribute('role', 'option');
        o.dataset.nom = c.nom;
        const im = document.createElement('img');
        im.className = 'ab-unites__mini';
        im.alt = '';
        im.loading = 'lazy';
        im.src = this.vignetteDe(c.nom);
        const t = document.createElement('span');
        /* la rupture reste listee, grisee et non selectionnable */
        t.textContent = c.dispo ? c.nom : c.nom + ' (' + this.dataset.rupture + ')';
        o.append(im, t);
        if (!c.dispo) o.setAttribute('aria-disabled', 'true');
        o.addEventListener('click', () => {
          if (!c.dispo) return;
          selC.value = c.nom;
          menu.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
          /* l'evenement fait le reste (peinture, panier) */
          selC.dispatchEvent(new Event('change', { bubbles: true }));
        });
        menu.appendChild(o);
      });

      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const ouvert = !menu.hidden;
        this.fermerMenus();
        menu.hidden = ouvert;
        btn.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
      });
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.fermerMenus();
      });
      selC.addEventListener('change', peindre, signal ? { signal } : undefined);
      peindre();
      return [btn, menu];
    }

    /* 15 oct. 2026, Quentin : un coloris ou une taille changé dans le panier
       se reporte sur la page (pack du haut, feuille collante, offre du bas,
       qui lisent tous les champs du haut). Seulement si un pack de ce nombre
       de culottes existe. */
    depuisPanier = async (e) => {
      const lignes = (e.detail && e.detail.lignes) || [];
      const n = lignes.length;
      if (!n) return;
      const carte = document.querySelector('albalina-paliers .ab-palier[data-quantite="' + n + '"]');
      if (!carte) return;
      if (!carte.classList.contains('is-actif')) carte.click();
      for (let i = 0; i < 30 && this.liste.querySelectorAll('.ab-unites__ligne').length !== n; i++) {
        await new Promise((r) => setTimeout(r, 70));
      }
      const champs = [...this.liste.querySelectorAll('.ab-unites__ligne')];
      if (champs.length !== n) return;
      champs.forEach((l, i) => {
        const selC = l.querySelector('[data-coloris]');
        const selT = l.querySelector('[data-taille]');
        if (selT && [...selT.options].some((o) => o.value === lignes[i].taille)) selT.value = lignes[i].taille;
        if (selC && [...selC.options].some((o) => o.value === lignes[i].coloris)) {
          selC.value = lignes[i].coloris;
          /* repeint le bouton et prévient le bas de page */
          selC.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      this.pousser();
    };

    fermerMenus = (e) => {
      document.querySelectorAll('.ab-unites__menu:not([hidden])').forEach((m) => {
        if (e && m.parentElement.contains(e.target)) return;
        m.hidden = true;
        const b = m.parentElement.querySelector('.ab-unites__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    };

    /* La quantité vient du palier actif : 2, 4 ou 6. */
    quantite() {
      const actif = document.querySelector('.ab-palier.is-actif');
      return actif ? parseInt(actif.dataset.quantite, 10) || 1 : 1;
    }

    surChangement = (e) => {
      const r = e.target;
      if (r && r.dataset && r.dataset.optionName === 'Lot') {
        setTimeout(() => { this.placer(); this.rendre(this.quantite()); }, 60);
      }
    };

    /* Horizon reconstruit le formulaire : on repose les lignes et les
       propriétés dès qu'elles disparaissent. */
    surveiller() {
      this.veille = new MutationObserver(() => {
        if (this.enCours || !this.isConnected) return;
        this.enCours = true;
        requestAnimationFrame(() => {
          if (!this.isConnected) { this.enCours = false; return; }
          this.placer();
          const voulu = this.quantite();
          if (this.liste.children.length !== voulu) this.rendre(voulu);
          else this.pousser();
          this.enCours = false;
        });
      });
      this.veille.observe(document.body, { childList: true, subtree: true });
    }

    rendre(n) {
      const avant = this.etat();
      this.liste.innerHTML = '';
      for (let i = 0; i < n; i++) {
        this.liste.appendChild(this.ligne(i, avant[i]));
      }
      this.pousser();
    }

    etat() {
      return [...this.liste.querySelectorAll('.ab-unites__ligne')].map((l) => ({
        coloris: l.querySelector('[data-coloris]').value,
        taille: l.querySelector('[data-taille]').value,
      }));
    }

    ligne(i, garde) {
      const el = document.createElement('div');
      el.className = 'ab-unites__ligne';

      const num = document.createElement('span');
      num.className = 'ab-unites__num';
      num.textContent = '#' + (i + 1);

      const dispo = this.coloris.filter((c) => c.dispo);
      const cChoisi = (garde && garde.coloris) || (dispo[0] && dispo[0].nom) || '';
      /* la taille donnée par le simulateur s'applique aussi aux culottes ajoutées */
      const tChoisie = (garde && garde.taille) || window.AlbalinaTaille || this.tailles[1] || this.tailles[0] || '';

      const champC = document.createElement('span');
      champC.className = 'ab-unites__champ ab-unites__champ--coloris';

      /* Le <select> reste, caché : c'est lui qui porte la valeur lue par etat()
         et pousser(). Le bouton et le menu ne font que le piloter. */
      const selC = document.createElement('select');
      selC.className = 'ab-unites__natif';
      selC.setAttribute('data-coloris', '');
      selC.setAttribute('aria-hidden', 'true');
      selC.tabIndex = -1;
      this.coloris.forEach((c) => {
        const o = document.createElement('option');
        o.value = c.nom;
        o.textContent = c.nom;
        if (c.nom === cChoisi) o.selected = true;
        selC.appendChild(o);
      });
      const [btn, menu] = this.champColoris(selC, null, i);
      selC.addEventListener('change', () => this.pousser());
      champC.append(selC, btn, menu);

      const champT = document.createElement('span');
      champT.className = 'ab-unites__champ ab-unites__champ--taille';
      const selT = document.createElement('select');
      selT.setAttribute('data-taille', '');
      selT.setAttribute('aria-label', 'Taille ' + (i + 1));
      this.tailles.forEach((t) => {
        const o = document.createElement('option');
        o.value = t;
        o.textContent = t;
        if (t === tChoisie) o.selected = true;
        selT.appendChild(o);
      });
      /* La taille choisie sur une ligne descend sur toutes celles d'en
         dessous. Demande de Quentin le 24 sept. 2026 : elle prend son lot,
         clique une seule taille, et ne corrige a la main que les lignes
         qu'elle veut differentes. Les lignes au-dessus ne bougent jamais. */
      selT.addEventListener('change', () => {
        this.propager(i, selT.value);
        this.pousser();
      });
      champT.appendChild(selT);

      el.append(num, champC, champT);
      return el;
    }

    propager(depuis, taille) {
      const lignes = [...this.liste.querySelectorAll('.ab-unites__ligne')];
      lignes.forEach((l, j) => {
        if (j <= depuis) return;
        const sel = l.querySelector('[data-taille]');
        if (sel && sel.value !== taille) sel.value = taille;
      });
    }

    formulaire() {
      return document.querySelector('form[action*="/cart/add"]');
    }

    /* La carte « 1 culotte » montre la culotte du coloris choisi sur la ligne
       #1 (demande de Quentin le 7 oct. 2026). Vignette de 120 px, environ
       15 Ko, chargee seulement au changement de coloris. */
    majVignetteCarte(coloris) {
      const img = document.querySelector('.ab-palier[data-quantite="1"] .ab-palier__vignette');
      const u = this.vignettes[coloris];
      if (!img || !u || !u.includes('cdn.shopify.com') || img.dataset.coul === coloris) return;
      const base = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
      img.src = base + (base.includes('?') ? '&' : '?') + 'width=120';
      img.dataset.coul = coloris;
    }

    /* Panier à l'unité. On prend la main sur l'envoi du formulaire produit
       (capture sur window : Horizon écoute en capture sur document, il passerait avant) : une ligne par coloris et taille, sur
       la variante « 1 culotte », quantité = nombre de culottes identiques.
       Puis on rejoue l'événement d'Horizon pour que le tiroir s'ouvre et se
       mette à jour comme d'habitude. Si une combinaison manque, on laisse
       Horizon envoyer le lot, comme avant. */
    envoyer = async (e) => {
      const f = e.target;
      if (!(f instanceof HTMLFormElement) || f !== this.formulaire()) return;
      if (!this.unites) return;
      const lignes = this.etat();
      if (!lignes.length) return;
      const items = [];
      for (const l of lignes) {
        const id = this.unites[l.coloris + '|' + l.taille];
        if (!id) return;
        const deja = items.find((x) => x.id === id);
        if (deja) deja.quantity += 1;
        else items.push({ id, quantity: 1 });
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      if (this.envoiEnCours) return;
      this.envoiEnCours = true;

      const racine = window.Shopify?.routes?.root || '/';
      const sections = [...document.querySelectorAll('cart-items-component')]
        .map((c) => c.dataset.sectionId).filter(Boolean);
      let ev = null;
      let differe = null;
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        differe = CartLinesUpdateEvent.createPromise();
        ev = CartLinesUpdateEvent;
        f.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map((x) => ({ merchandiseId: String(x.id), quantity: x.quantity })),
          promise: differe.promise,
        }));
      } catch (err) { console.warn('[albalina-unites] événements', err); }

      try {
        /* 15 oct. 2026, Quentin : le pack choisi REMPLACE les culottes à
           l'unité déjà au panier. Même pack déjà au panier : on rouvre juste
           le tiroir, sans rien ajouter. Pack modifié : le panier prend le
           nouveau pack (quantités absolues). */
        const avant = await (await fetch(racine + 'cart.js')).json();
        const ids = new Set(Object.values(this.unites).map(Number));
        const actuel = {};
        for (const it of avant.items) {
          if (ids.has(it.variant_id)) actuel[it.variant_id] = (actuel[it.variant_id] || 0) + it.quantity;
        }
        const voulu = {};
        for (const x of items) voulu[x.id] = x.quantity;
        const tous = new Set([...Object.keys(actuel), ...Object.keys(voulu)]);
        const identique = [...tous].every((id) => (actuel[id] || 0) === (voulu[id] || 0));
        let rep = null;
        let panier = avant;
        if (!identique) {
          const updates = {};
          tous.forEach((id) => { updates[id] = voulu[id] || 0; });
          const ordre = [];
          for (const l of lignes) ordre.push(this.unites[l.coloris + '|' + l.taille]);
          const r = await fetch(racine + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates, attributes: { _abg_ordre: ordre.join(',') }, sections: sections.join(',') }),
          });
          rep = await r.json();
          panier = rep.items ? rep : await (await fetch(racine + 'cart.js')).json();
        }
        if (differe) differe.resolve({
          cart: ev.createCartFromAjaxResponse(panier),
          detail: {
            items: panier.items,
            source: 'albalina-unites',
            sections: rep ? rep.sections : undefined,
            didError: Boolean(rep && rep.status),
          },
        });
        if (rep && rep.status) console.warn('[albalina-unites] ajout refusé', rep);
      } catch (err) {
        console.warn('[albalina-unites] ajout', err);
        if (differe) differe.reject(err);
      } finally {
        this.envoiEnCours = false;
      }
    };

    /* La ligne #1 fixe la variante par le sélecteur natif.
       Les suivantes partent en propriétés de ligne. */
    pousser() {
      const lignes = this.etat();
      if (!lignes.length) return;
      if (this.quantite() === 1) this.majVignetteCarte(lignes[0].coloris);

      const clic = (nomOption, valeur) => {
        const r = [...document.querySelectorAll('input[type="radio"][data-option-name="' + nomOption + '"]')]
          .find((x) => x.value === valeur);
        if (r && !r.checked) r.click();
      };
      clic('Coloris', lignes[0].coloris);
      clic('Taille', lignes[0].taille);

      const f = this.formulaire();
      if (!f) return;
      /* 15 oct. 2026 : ne rien toucher si les champs sont déjà justes, sinon
         la surveillance de la page se relance elle-même sans fin */
      const voulu = lignes.map((l, i) => 'properties[' + this.dataset.libelleUnite + ' #' + (i + 1) + ']=' + l.coloris + ' / ' + l.taille).join('|');
      const deja = [...f.querySelectorAll('input[data-ab-unite]')].map((x) => x.name + '=' + x.value).join('|');
      if (deja === voulu) return;
      f.querySelectorAll('input[data-ab-unite]').forEach((i) => i.remove());
      lignes.forEach((l, i) => {
        const inp = document.createElement('input');
        inp.type = 'hidden';
        inp.setAttribute('data-ab-unite', '');
        inp.name = 'properties[' + this.dataset.libelleUnite + ' #' + (i + 1) + ']';
        inp.value = l.coloris + ' / ' + l.taille;
        f.appendChild(inp);
      });
    }
  }

  if (!customElements.get('albalina-unites')) {
    customElements.define('albalina-unites', AlbalinaUnites);
  }
  } catch(e) { console.error(e); }
})();

})();
